import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { MemberBillDto } from '../../types';
import './Session.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://localhost:5001/api';

const PublicBill: React.FC = () => {
  const { sessionId, memberId } = useParams<{ sessionId: string; memberId: string }>();
  const [bill, setBill] = useState<MemberBillDto | null>(null);
  const [restaurantName, setRestaurantName] = useState('');
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [tip, setTip] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBill = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/sessions/${sessionId}/member/${memberId}/bill`
        );
        setBill(res.data.bill);
        setRestaurantName(res.data.restaurantName);
        setDeliveryFee(res.data.deliveryFee);
        setTip(res.data.tip);
      } catch (err: any) {
        setError(err.response?.data?.message || 'Failed to load bill');
      } finally {
        setLoading(false);
      }
    };
    fetchBill();
  }, [sessionId, memberId]);

  if (loading) return <p className="loading">Loading your bill...</p>;
  if (error) return <p className="loading">{error}</p>;
  if (!bill) return <p className="loading">Bill not found</p>;

  return (
    <div className="page-container">
      <div className="public-bill">
        <div className="bill-header">
          <h1>حسبنا كام</h1>
          <h2>{restaurantName}</h2>
          <p className="bill-for">Bill for: <strong>{bill.memberName}</strong></p>
        </div>

        <table className="bill-table">
          <thead>
            <tr><th>Item</th><th>Price</th><th>Qty</th><th>Your Share</th></tr>
          </thead>
          <tbody>
            {bill.items.map((item, idx) => (
              <tr key={idx}>
                <td>{item.itemName}</td>
                <td>{item.unitPrice.toFixed(2)}</td>
                <td>{item.quantity}{item.sharedBetween > 1 && ` (shared ${item.sharedBetween}-way)`}</td>
                <td>{item.yourShare.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="bill-summary-card">
          <div className="bill-line">
            <span>Items Subtotal</span>
            <span>{bill.itemsTotal.toFixed(2)}</span>
          </div>
          <div className="bill-line">
            <span>Delivery Fee Share</span>
            <span>{bill.deliveryShare.toFixed(2)}</span>
          </div>
          <div className="bill-line">
            <span>Tip Share</span>
            <span>{bill.tipShare.toFixed(2)}</span>
          </div>
          <div className="bill-line bill-total">
            <span>Your Total</span>
            <span>{bill.grandTotal.toFixed(2)}</span>
          </div>
        </div>

        <p className="bill-footer">
          Delivery: {deliveryFee.toFixed(2)} | Tip: {tip.toFixed(2)} (split equally)
        </p>
      </div>
    </div>
  );
};

export default PublicBill;
